import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Reveal, Eyebrow, ArrowLink } from "@/components/Reveal";

export default function Insights() {
  return (
    <main className="bg-[#F6F4F0] text-[#1F1E1B] antialiased">
      <Navbar />

      <section data-testid="insights-hero" className="pt-40 lg:pt-52 pb-28 lg:pb-44 min-h-[70vh]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <Eyebrow>Insights</Eyebrow>
            <h1 className="mt-8 font-serif text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight text-[#1F1E1B] leading-[1.05] max-w-5xl">
              Perspectives, <span className="italic">in due course.</span>
            </h1>
            <p className="mt-10 max-w-2xl text-base sm:text-lg font-light leading-relaxed text-[#6E6A61]">
              Commentary on private capital, sports ownership, real assets and significant transactions
              will be published here in due course.
            </p>
            <p className="mt-6 max-w-2xl text-base sm:text-lg font-light leading-relaxed text-[#6E6A61]">
              For a preliminary view on a specific matter, please contact the firm directly.
            </p>
            <div className="mt-12">
              <ArrowLink to="/contact" testid="insights-contact-link">
                Contact PJG Capital Partners
              </ArrowLink>
            </div>
          </Reveal>
        </div>
      </section>

      <Footer />
    </main>
  );
}
